import Quill from 'quill'
import { IMAGE_ID_ATTRIBUTE, IMAGE_ID_BLOT_NAME, IMAGE_ID_CLASS_NAME } from './constants'
import { formatFileSize } from '@/utils'
import { FILE_TYPES, materialToFileType } from '@/pages/setting/MaterialLibrary/utils'
import { FileIcon } from '../SvgIcon'

const BlockEmbed = Quill.import('blots/block/embed')

class ImageIdEmbed extends BlockEmbed {
	public static blotName = IMAGE_ID_BLOT_NAME
	public static tagName = 'div'
	public static className = IMAGE_ID_CLASS_NAME

	public static create(value: { id: number }) {
		const node = super.create() as HTMLElement
		node.setAttribute(IMAGE_ID_ATTRIBUTE, String(value.id))
		node.setAttribute('contenteditable', 'false')
		node.classList.add('jekka-rte-image-embed')
		node.dataset.state = 'loading'

		node.innerHTML = `
      <div class="quill-material-card">
        <div class="quill-material-card-info">
          <img src="" draggable="false" class="jekka-rte-image-embed-img" alt="">
          <div class="quill-material-card-info-text">
            <div class="quill-material-card-info-name" title=""></div>
            <div class="quill-material-card-info-desc">素材id <span class="material-id"></span> · <span class="material-size"></span></div>
          </div>
        </div>
        <button 
          type="button" class="jekka-rte-image-embed-remove" contenteditable="false"
          aria-label="remove image"
        >×</button>
      </div>
    `
		const remove = node.querySelector('.jekka-rte-image-embed-remove')!
		remove.addEventListener('mousedown', e => e.preventDefault())
		remove.addEventListener('click', e => {
			e.preventDefault()
			e.stopPropagation()
			const embedNode = remove.closest<HTMLElement>(`.${IMAGE_ID_CLASS_NAME}`)
			const blot = embedNode && Quill.find(embedNode)
			blot?.remove()
		})

		return node
	}

	public static value(node: HTMLElement) {
		const id = Number(node.getAttribute(IMAGE_ID_ATTRIBUTE))
		return Number.isNaN(id) ? undefined : { id }
	}
}

Quill.register(ImageIdEmbed, true)

/** Applies a resolved url to an existing embed node. A plain attribute write, safe post-mount. */
export const setEmbedResolved = (node: HTMLElement, data: Record<string, any>) => {
	node.dataset.state = 'loaded'
	if (!data) {
		return
	}

	try {
		node.querySelector('img')!.src = data.oss_url
		node.querySelector('.quill-material-card-info-name')!.textContent = data.name
		node.querySelector('.quill-material-card-info-name')!.setAttribute('title', data.name)
		node.querySelector('.material-id')!.textContent = data.id
		node.querySelector('.material-size')!.textContent = formatFileSize(Number(data.file_size)) || ''
		const fileType = materialToFileType(data.material_type)
		console.log(fileType)
		if (fileType != FILE_TYPES.IMAGE) {
			const img = node.querySelector('img')!
			let newNode: HTMLElement
			if (fileType == FILE_TYPES.VIDEO) {
				newNode = document.createElement('video')
				// @ts-ignore
				newNode.src = data.oss_url
				// @ts-ignore
				newNode.playsInline = true
			} else {
				newNode = document.createElement('div')
				newNode.innerHTML = `
        	<svg
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="45663"
            width="36"
            height="36"
          >
            <path
              d="M361.813333 399.36h460.8v-54.613333c0-17.066667-17.066667-34.133333-34.133333-34.133334h-300.373333L443.733333 228.693333H296.96c-17.066667 0-34.133333 17.066667-34.133333 34.133334v334.506666l34.133333-146.773333c6.826667-27.306667 34.133333-51.2 64.853333-51.2z"
              fill="#FF7300"
              p-id="45664"
            ></path>
            <path
              d="M860.16 433.493333H368.64c-17.066667 0-37.546667 17.066667-44.373333 34.133334l-58.026667 259.413333c-3.413333 6.826667 0 17.066667 3.413333 20.48 6.826667 6.826667 17.066667 13.653333 27.306667 13.653333H785.066667c17.066667 0 37.546667-17.066667 44.373333-34.133333l58.026667-259.413333c3.413333-17.066667-10.24-34.133333-27.306667-34.133334z"
              fill="#FF7300"
              p-id="45665"
            ></path>
            <path
              d="M512 0C228.693333 0 0 228.693333 0 512s228.693333 512 512 512 512-228.693333 512-512S795.306667 0 512 0z m344.746667 744.106667c-6.826667 27.306667-37.546667 51.2-64.853334 51.2H266.24c-27.306667 0-44.373333-20.48-37.546667-47.786667V245.76c0-27.306667 23.893333-51.2 51.2-51.2h187.733334L512 276.48h293.546667c27.306667 0 51.2 23.893333 51.2 51.2v71.68h30.72c27.306667 0 44.373333 23.893333 37.546666 51.2l-68.266666 293.546667z"
              fill="#FF7300"
              p-id="45666"
            ></path>
          </svg>
        `
			}
			newNode.className = 'jekka-rte-image-embed-img'
			img.replaceWith(newNode)
		}
	} catch (e) {
		console.error(e)
	}
}

/** Marks an embed node as failed to resolve. A plain attribute write, safe post-mount. */
export const setEmbedErrored = (node: HTMLElement) => {
	node.dataset.state = 'error'
}

export default ImageIdEmbed
